import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import j22Ratings from "../../../../src/data/articles/cube-prospective-jumpstart-2022/j22-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  j22Ratings,
  ProspectiveIntro,
  React
};